import { UserState } from './../../users/user.state';
import { IOrganization } from './../../models/organization';
import { UserService } from './../../services/user/user.service';
import { Select, Store } from '@ngxs/store';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { ThemeService } from '../../services/theme.service';
import { ApplicationState } from '../../state/app.state';
import { Observable, Subject, of } from 'rxjs';
import { IOrganizationBase } from '../../models/organization';
import { takeUntil, switchMap } from 'rxjs/operators';
import { App } from '../../state/app.actions';
import { Router } from '@angular/router';
import { IMemberResult } from '../../models/member';
import { User } from '../../users/user.actions';
import { ReportService } from '../../services/reports/report.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [NgbDropdownConfig],
})
export class HeaderComponent implements OnInit {
  unSubscribeAll$ = new Subject<void>();

  @Select(ApplicationState.getOrganizations)
  organizations$: Observable<Array<IOrganizationBase>>;

  @Select(ApplicationState.getCurrentOrganization)
  currentOrganization$: Observable<IOrganizationBase>;

  @Select(ApplicationState.getOrganizations)
  userOrganizations$: Observable<Array<IOrganization>>;

  userOrganizations: IOrganizationBase[];
  selectedOrganization: IOrganizationBase;

  organization: IOrganization;

  @Input() anonymousMode: boolean = false;
  @Input() showNotifMenu: boolean = false;
  @Input() showToggleMenu: boolean = false;
  @Input() darkClass: string = '';
  @Output() toggleSettingDropMenuEvent = new EventEmitter();
  @Output() toggleNotificationDropMenuEvent = new EventEmitter();

  organizationLogoUrl: string | null = null;

  constructor(
    private cdr: ChangeDetectorRef,
    private config: NgbDropdownConfig,
    private userService: UserService,
    private router: Router,
    private themeService: ThemeService,
    private store: Store,
    private reportService: ReportService
  ) {
    config.placement = 'bottom-right';
  }

  ngOnInit() {
    this.initSubscribers();
  }

  initSubscribers(): void {
    this.currentOrganization$.pipe(takeUntil(this.unSubscribeAll$)).subscribe({
      next: (organization) => {
        this.organization = organization as IOrganization;
        this.selectedOrganization = organization;
        if (organization && organization['organization']) {
          this.organization = organization['organization'];
        }

        this.setValueFromToken();
        this.loadOrganizationLogo();
      },
    });

    this.organizations$.pipe(takeUntil(this.unSubscribeAll$)).subscribe({
      next: (organizations) => {
        this.userOrganizations = organizations;
      },
    });

    //get user organizations
    this.userOrganizations$.pipe(takeUntil(this.unSubscribeAll$)).subscribe({
      next: (orgs) => {
        this.userOrganizations = orgs;
      },
    });
  }

  setValueFromToken(): void {
    //Set Current Organization
    if (!this.organization && localStorage.getItem('organization')) {
      this.organization = JSON.parse(localStorage.getItem('organization'));
      this.store.dispatch(
        new App.Actions.SetCurrentOrganization(this.organization)
      );

      if (localStorage.getItem('user')) {
        const user = JSON.parse(localStorage.getItem('user')) as IMemberResult;

        if (user.organizations) {
          const organizations = user.organizations.map((org) => {
            return {
              address: org.organization['address'],
              name: org.organization['name'],
              id: org.organization['_id'],
              subscriptionStatus: org.organization.subscriptionStatus,
              organizationId: org.organization['_id'],
              roles: org.organization.roles,
              url: org.organization['url'],
              email: org.organization['email'],
              phone: org.organization['phone'],
              description: org.organization['description'],
              logo: org.organization['logo'],
              tags: org.organization['tags'],
            } as IOrganizationBase;
          });
          this.store.dispatch(
            new App.Actions.SetCurrentOrganization(user.currentOrganization)
          );
          this.store.dispatch(new App.Actions.SetOrganizations(organizations));
          this.store.dispatch(new User.Actions.SetLoginInformation(user));
          this.store.dispatch(new App.Actions.SetRoles());
        }
      }
    }
  }
  toggleSettingDropMenu() {
    this.toggleSettingDropMenuEvent.emit();
  }

  toggleNotificationDropMenu() {
    this.toggleNotificationDropMenuEvent.emit();
  }

  toggleSideMenu() {
    this.themeService.showHideMenu();
  }

  changeOrganization(org: IOrganizationBase): void {
    this.organization = org as IOrganization;
    localStorage.setItem('organization', JSON.stringify(this.organization));
    // Single dispatch — the NGXS action calls setCurrentOrganization internally.
    // Do NOT also call userService.setCurrentOrganization() here; that would fire
    // a second concurrent API request that races to reset allRoles in state and
    // triggers multiple SetRoles() calls, crashing the transactions page.
    this.store.dispatch(new App.Actions.SetCurrentOrganization(org));

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/transactions/index/`], {
        queryParams: { time: new Date().getMilliseconds() },
      });
    });
    this.cdr.detectChanges();
  }

  loadOrganizationLogo(): void {
    if (!this.organization || !this.organization.id) {
      return;
    }

    this.reportService
      .getOrganizationLogoUrl(this.organization.id)
      .pipe(
        takeUntil(this.unSubscribeAll$),
        switchMap((url) => {
          if (url && url.logo)
            return this.reportService.getOrganizationLogo(
              this.organization.id,
              url.logo
            );
          else return of(null);
        })
      )
      .subscribe((logo) => {
        if (logo && logo.src) {
          this.organizationLogoUrl = logo.src;
          this.cdr.detectChanges();
        }
      });
  }
}
